var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('awesome-vue-star-rating',{staticClass:"-mt-3",attrs:{"star":_vm.params.data.rate,"disabled":"","maxstars":5,"starsize":"lg","hasresults":false,"hasdescription":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }